
<template lang="pug">
  .container
    .callback
      h2.subtitle Logging in with Google ...
</template>

<script>

export default {
  name: 'callback',
  layout: 'login',
  mounted () {
    const data = this.$route.query
    this.$store.dispatch('loginWithService', { service: 'google', data })
      .then(() => {
        this.$router.push({ path: `/` })
      })
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

.title {
  font-family: 'Quicksand', 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  display: block;
  font-weight: 300;
  font-size: 100px;
  color: #35495e;
  letter-spacing: 1px;

.subtitle {
  font-weight: 300;
  font-size: 42px;
  color: #526488;
  word-spacing: 5px;
  padding-bottom: 15px;

.links {
  padding-top: 15px;


}
}
}
}</style>



// WEBPACK FOOTER //
// src/pages/login/google-callback.vue